import { Component } from '@angular/core';

@Component({
  selector: 'app-cont-camp',
  imports: [],
  templateUrl: './cont-camp.html',
  styleUrl: './cont-camp.css'
})
export class ContCamp {

}
